import * as React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";

import ApplicationLayout from "components/layout/ApplicationLayout";
import { VideoTutorialButton } from "components/modal/video-modal/video-tutorial-button/VideoTutorialButton";
import { VideoModal } from "components/modal/video-modal/VideoModal";
import Products from "components/products/Products";
import { HOME_ROUTE } from "components/router/Routes";
import { TutorialVideoLink } from "domain/tutorialVideos";
import { useIsAiHomeEnabled } from "services/feature/useIsAiHomeEnabled";
import { StoreState } from "store";

export default function ProductsView(): JSX.Element {
    const { t } = useTranslation();
    const isAiHomeEnabled = useIsAiHomeEnabled();

    const tenantDetails = useSelector(
        (state: StoreState) => state.tenantDetailsReducer.stack[state.tenantDetailsReducer.stack.length - 1]
    );

    const [showVideoModal, setShowVideoModal] = React.useState(false);
    const watchTutorialButton =
        tenantDetails && tenantDetails.contractType !== "TRIAL" ? (
            <VideoTutorialButton onClick={() => setShowVideoModal(true)} />
        ) : undefined;

    if (!isAiHomeEnabled) {
        return <Redirect to={HOME_ROUTE.path} />;
    }

    return (
        <>
            <ApplicationLayout
                viewTitle={t("Routes.yourProducts")}
                view={<Products />}
                mainRoute={HOME_ROUTE}
                viewActions={watchTutorialButton}
                hideActions={watchTutorialButton}
            />
            <VideoModal
                isOpen={showVideoModal}
                hideModal={() => setShowVideoModal(false)}
                linkUrl={TutorialVideoLink.HOME}
            />
        </>
    );
}
